export default __webpack_public_path__ + "static/media/man-limbs.3ff48b21.png";